<template>
  <div>
    <el-form class="serach-form" :inline="true" :model="filters" size="small">
      <el-form-item class="m-l-14">
        <el-checkbox border v-model="filters.isPost" @change="checkChange"
          >只看班委</el-checkbox
        >
      </el-form-item>
      <el-form-item class="select_btn">
        <el-select
          class="select_btn_style"
          v-model="filters.graduationStatus"
          placeholder="结业状态"
        >
          <el-option
            v-for="(item, i) in graduationStatusData"
            :key="i"
            :label="item.paramValue"
            :value="item.paramKey"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item class="m-l-14">
        <el-input
          prefix-icon="el-icon-search"
          size="small"
          v-model.trim="filters.name"
          placeholder="姓名"
        ></el-input>
      </el-form-item>
      <el-form-item>
        <butn btntype="primary" title="查询" @click="query"></butn>
        <butn title="重置" @click="reset" class="czButn"></butn>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import butn from "@/components/button/index";

export default {
  components: { butn },
  props: {
    graduationStatusData: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  data() {
    return {
      filters: {
        isPost: false,
      },
    };
  },
  methods: {
    checkChange() {
      this.query();
    },
    query() {
      this.$emit("search", {
        ...this.filters,
        isPost: this.filters.isPost ? 1 : 0,
      });
    },
    reset() {
      this.filters = { isPost: false };
      this.query();
    },
  },
};
</script>

<style lang="scss" scoped>
</style>